import { render, staticRenderFns } from "./RouteOfAdministration.vue?vue&type=template&id=0677900a&"
import script from "./RouteOfAdministration.vue?vue&type=script&lang=js&"
export * from "./RouteOfAdministration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports